module.exports = __webpack_public_path__ + "sports-48-x-48.15e16be4e558888246bc.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/src/assets/fonts/line-icons-pro/sports/webfont/sports-48-x-48.eot
// module id = ../../../../../src/assets/fonts/line-icons-pro/sports/webfont/sports-48-x-48.eot
// module chunks = styles